import { SxProps } from "@mui/material";
import { Controller, RegisterOptions, useFormContext } from "react-hook-form";
import CommonSelectField, { SelectOption } from "./CommonSelectField";

type Props = {
  name: string;
  options: SelectOption[];
  fullWidth?: boolean;
  disabled?: boolean;
  placeholder?: string;
  inputSx?: SxProps;
  required?: boolean;
  rules?: RegisterOptions;
  error?: boolean;
  multiple?: boolean;
  showChips?: boolean;
  label?: string;
  showCheckboxes?: boolean;
  readonly?: boolean;
  chipVariant?: "filled" | "outlined";
};

const SelectField = ({
  name,
  options,
  fullWidth = true,
  disabled = false,
  placeholder,
  inputSx = {},
  required = false,
  rules,
  error = false,
  multiple = false,
  showChips = false,
  label,
  showCheckboxes = false,
  readonly = false,
  chipVariant = "filled",
}: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        ...(required && {
          required: { value: true, message: `${name}_required` },
        }),
        ...rules,
      }}
      render={({ field: { value, onChange } }) => (
        <CommonSelectField
          name={name}
          value={value || (multiple ? [] : "")}
          onChange={onChange}
          options={options}
          multiple={multiple}
          fullWidth={fullWidth}
          disabled={disabled}
          placeholder={placeholder}
          inputSx={inputSx}
          error={error}
          showChips={showChips}
          label={label}
          showCheckboxes={showCheckboxes}
          readonly={readonly}
          chipVariant={chipVariant}
        />
      )}
    />
  );
};

export default SelectField;
